import React from 'react';
import { Button, Form, Header, Segment } from 'semantic-ui-react';

import { TipoNuevoCompromiso } from './tipos';

interface Props {
    alRegistrarCompromiso(compromiso: TipoNuevoCompromiso): Promise<void>;
}

interface State extends TipoNuevoCompromiso {
    readonly mostrandoFormulario: boolean;
    readonly registrando: boolean;
}

const stateInicial: State = {
    tipo: 'compromiso',
    observaciones: '',
    fechaAdicional: '',
    mostrandoFormulario: false,
    registrando: false,
    habilitadosParaClases: false,
    habilitadosParaMaterial: false,
    numeroDeCuota: undefined,
};

class FormularioCrearCompromiso extends React.Component<Props, State> {
    public readonly state: State = stateInicial;

    public render() {
        const {
            tipo,
            observaciones,
            fechaAdicional,
            mostrandoFormulario,
            registrando,
            habilitadosParaClases,
            habilitadosParaMaterial,
            numeroDeCuota,
        } = this.state;

        if (!mostrandoFormulario) {
            return (
                <Button
                    primary
                    icon='add'
                    labelPosition='left'
                    content='Nuevo'
                    onClick={() => this.setState({ mostrandoFormulario: true })}
                />
            );
        }

        const etiquetaFecha =
            tipo === 'compromiso'
                ? 'Fecha en que se compromete a pagar'
                : tipo === 'retiro'
                ? 'Fecha en que se retiró'
                : '';

        return (
            <Segment>
                <Header as='h3'>Nuevo compromiso de pago</Header>
                <Form
                    onSubmit={() => {
                        this.setState({ registrando: true });
                        this.props
                            .alRegistrarCompromiso({
                                ...(this.state as TipoNuevoCompromiso),
                            })
                            .then(() => this.setState(stateInicial))
                            .catch(error => {
                                // TODO: Notificar el error al usuario
                                this.setState(stateInicial);
                            });
                    }}
                >
                    <Form.Group>
                        <Form.Input
                            required
                            width='6'
                            label={etiquetaFecha}
                            type='date'
                            value={fechaAdicional}
                            onChange={(_e, { value }) => {
                                this.setState({ fechaAdicional: value });
                            }}
                        />
                        <Form.Select
                            width='6'
                            label='Número de cuota'
                            options={[
                                { key: 0, value: '', text: 'No especificado' },
                                ...Array.from(Array(12).keys()).map(x => ({
                                    key: x + 1,
                                    value: x + 1,
                                    text: `Cuota ${x + 1}`,
                                })),
                            ]}
                            value={numeroDeCuota}
                            onChange={(_e, { value }) => {
                                const numero = value === '' ? undefined : (value as number);
                                this.setState({ numeroDeCuota: numero });
                            }}
                        />
                    </Form.Group>

                    <React.Fragment>
                        <Form.Checkbox
                            label={
                                'Los alumnos están habilitados para entrar a clases hasta la' +
                                ' fecha indicada'
                            }
                            checked={habilitadosParaClases}
                            onChange={(_e, { checked }) => {
                                this.setState({ habilitadosParaClases: checked as boolean });
                            }}
                        />
                        <Form.Checkbox
                            label={
                                'Los alumnos están habilitados para recibir material y puntajes' +
                                ' hasta la fecha indicada'
                            }
                            checked={habilitadosParaMaterial}
                            onChange={(_e, { checked }) => {
                                this.setState({ habilitadosParaMaterial: checked as boolean });
                            }}
                        />
                    </React.Fragment>

                    <Form.TextArea
                        label='Observaciones'
                        placeholder='Cualquier comentario adicional que necesite'
                        value={observaciones}
                        onChange={(_e, { value }) => {
                            this.setState({ observaciones: value as string });
                        }}
                    />
                    <Form.Group>
                        <Form.Button
                            primary
                            content='Registrar'
                            loading={registrando}
                            disabled={registrando}
                        />
                        <Form.Button
                            type='button'
                            content='Cancelar'
                            onClick={() => this.setState(stateInicial)}
                        />
                    </Form.Group>
                </Form>
            </Segment>
        );
    }
}

export default FormularioCrearCompromiso;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Compromisos/FormularioNuevoComentario.tsx